import { useMemo } from "react";

const useApiBase = () =>
  useMemo(() => {
    const envBackend = process.env.REACT_APP_BACKEND_IP;
    const envApiBase = process.env.REACT_APP_API_BASE;

    if (envBackend) {
      return `http://${envBackend}`;
    }

    if (envApiBase != null && String(envApiBase).trim() !== "") {
      return String(envApiBase).replace(/\/$/, "");
    }

    return "http://localhost:8000";
  }, []);

export default useApiBase;
